export const GET_REPORT_METRICS_DETAIL_API =
  'thor/v2/crm/listing-performance/marketing-metric/report/detail';
